import { ShoppingBag } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { useTranslation } from 'react-i18next';

interface EmptyCartProps {
  onClose: () => void;
}

export function EmptyCart({ onClose }: EmptyCartProps) {
  const { t } = useTranslation();

  return (
    <div className='py-8 text-center'>
      <ShoppingBag className='mx-auto h-12 w-12 text-muted-foreground opacity-50 mb-3' />
      <p className='text-muted-foreground'>{t('cartIsEmpty')}</p>
      <Button variant='outline' className='mt-4' onClick={onClose}>
        {t('browseMenu')}
      </Button>
    </div>
  );
}
